const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  SIGNUP: '/signup',
  CREATE_CONTRACT: '/create-contract',
  SELECT_PROFESSION: '/select-profession',
  VIEW_CONTRACT: '/view-contract',
};

export default ROUTES;